import { useEffect } from 'react';

import { useRouter } from 'next/router';

import pageview from '@/utils/GTM/pageview';

export type WordCountType =
	| ''
	| '0-200'
	| '201-600'
	| '601-1000'
	| '1001-1600'
	| '1600+';

interface IPageviewParams {
	pageType:
		| 'homepage'
		| 'article'
		| 'category'
		| 'vertical'
		| 'author'
		| 'tag'
		| 'search'
		| '404'
		| 'page'
		| 'account';
	author: string;
	vertical: string;
	category: string;
	wordCount?: WordCountType;
}

/**
 * Hook to register GTM page views.
 */
const useGTMPageView = (
	additionalParams: IPageviewParams = {
		pageType: 'page',
		author: '',
		vertical: '',
		category: '',
		wordCount: '',
	}
) => {
	const router = useRouter();

	useEffect(() => {
		pageview(router.asPath, 'pageview', additionalParams);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};

export default useGTMPageView;
